// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__I201i","lost":"LoginForm_lost__UhF2B","register":"LoginForm_register__GcSjQ","subtitle":"LoginForm_subtitle__EQ37E"};